import React, { Component } from 'react';
import { Table } from "react-bootstrap";

import { ConsultaSecciones } from '../../funciones/functionEstadistica';

import AlumnosSeccion from './AlumnosSeccion';

class SeccionesSem extends Component {
    state = {
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando Secciones</React.Fragment>,
        secciones: []
    }

    componentDidMount = () => {
        ConsultaSecciones (this.props.semestre, (resp) => {
            this.setState({secciones: resp})
        })
    }

    secciones = () => {
        const { secciones, preloader } = this.state;

        if (secciones.length === 0) return (
            <tr>
                <td colSpan={2} align="center">{preloader}</td>
            </tr>
        )

        return(
            secciones.map(option => (
                <AlumnosSeccion key = {option.id} datos = {option} />
            ))
        )
    }

    render() {
        const styles = {
            padding: 2, fontSize: 12
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">Alumnos por Sección</div>
                <div className="table-responsive custom-mt-10" style={{overflowX: "hidden", overflowY: "auto", maxHeight: "70vh"}}>
                    <Table hover style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="50%" style={styles}><strong>Sección</strong></td>
                                <td align="center" width="50%" style={styles}><strong>Estadsística</strong></td>
                            </tr>
                            {this.secciones()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}
 
export default SeccionesSem;


// WEBPACK FOOTER //
// ./src/views/Opciones/SeccionesSem.jsx